'use strict';

module.exports = {
  id: 'throwOnError',
  after: function after(res) {
    if (!res.ok) {
      throw res;
    }

    return res;
  }
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty-lib/modules/http-state-source/hooks/throwOnError.js
 ** module id = 568
 ** module chunks = 0
 **/